import React from 'react';
import { Link } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import { number_format } from 'functions';
import Card from 'components/Card';

export default function CardCobranca({ cliente, company, month, year, hasTravels }) {
  const loadsQty = cliente.total_cargas ?? cliente.loads_qty;
  const loadsValue = cliente.valor_total_cargas ?? cliente.loads_fare_company_sum;
  const travelsQty = cliente.total_viagens ?? cliente.travels_qty;
  const travelsValue = cliente.valor_total_viagens ?? cliente.travels_balance_sum;
  const clientId = cliente.person_client_id ?? cliente.client_id ?? cliente.id;

  const columnsStyle = hasTravels
    ? {
        display: 'grid',
        gridTemplateColumns:
          'minmax(360px, 2.4fr) minmax(200px, 1fr) minmax(200px, 1fr) minmax(120px, 0.6fr)',
        columnGap: 32,
        alignItems: 'start',
      }
    : {
        display: 'grid',
        gridTemplateColumns: 'minmax(360px, 2.4fr) minmax(200px, 1fr) minmax(200px, 1fr)',
        columnGap: 32,
        alignItems: 'start',
      };
  return (
    <Card bordered style={{ marginBottom: '10px', padding: '16px 24px' }}>
      <div style={columnsStyle}>
        <div>
          <Typography variant="caption" component="p" gutterBottom>
            <strong>Cliente</strong>
          </Typography>
          <Typography variant="body2" gutterBottom>
            {cliente.social_name}
          </Typography>
          <Typography variant="caption" component="p" gutterBottom>
            <strong>CNPJ</strong>
          </Typography>
          <Typography variant="body2" gutterBottom>
            {cliente.cgccpf}
          </Typography>
        </div>
        <div>
          <Typography variant="caption" component="p" gutterBottom>
            <strong>Cargas lançadas</strong>
          </Typography>
          <Typography variant="body2" gutterBottom>
            {loadsQty}
          </Typography>
          <Typography variant="caption" component="p" gutterBottom>
            <strong>Total</strong>
          </Typography>
          <Typography variant="body2" gutterBottom>
            R$ {number_format(loadsValue, 2, ',', '.')}
          </Typography>
        </div>

        <div>
          <Typography variant="caption" component="p" gutterBottom>
            <strong>Viagens realizadas</strong>
          </Typography>
          <Typography variant="body2" gutterBottom>
            {travelsQty}
          </Typography>
          <Typography variant="caption" component="p" gutterBottom>
            <strong>Total</strong>
          </Typography>
          <Typography variant="body2" gutterBottom>
            R$ {number_format(travelsValue, 2, ',', '.')}
          </Typography>
        </div>
        {hasTravels && (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
            <div style={{ textAlign: 'right' }}>
              <Link
                style={{
                  fontWeight: 'bold',
                  textTransform: 'uppercase',
                }}
                to={`/relatorios/cobrancas/${company}/${clientId}/${month}/${year}`}
              >
                Ver mais
              </Link>
            </div>
          </div>
        )}
      </div>
    </Card>
  );
}
